export const CONFIG_KEY = 'ticketerFrontendKit'
